import AdminBottomImage from './landingPage/AdminBottomImage.svg';
import Facebook from './landingPage/Facebook.png';
import instagram from './landingPage/instagram.png';
import katonHeaderLogo from './landingPage/KATON_Logo_white.svg';
import kid from './landingPage/kid.svg';
import linkedin from './landingPage/linkedin.png';
import teacherLoginBottomImage from './landingPage/teacherLoginBottomImage.svg';
import ptaBottomImage from './landingPage/ptaBottomImage.svg';
import tiktokIcon from './landingPage/tiktokIcon.png';
import xIcon from './landingPage/X.png';
import youtubeIcon from './landingPage/youtubeIcon.png';
import underContstructionImage from './under-construction.png';
import ptaCornerImage from './PTA/ptaCornerImage.png';
import splashImage from "./landingPage/splashScreenLogo.svg";
import landingPageImage from "./landingPage/landingPageImage.png";
import adminLoginPageLamp from './landingPage/adminLoginPageLamp.svg'
import adminLoginPageLampPng from './landingPage/adminLoginPageLamp.png'
import schoolProfileImage from "./SchoolAdmin/schoolProfileImage.svg"
import DashboardIcon from "./Dashboard/DashboardIcon.svg"
import HelpIcon from "./Dashboard/HelpIcon.svg"
import LogoutIcons from "./Dashboard/LogoutIcon.svg"
import NotificationIcon from "./Dashboard/NotificationIcon.svg"
import SettingsIcons from "./Dashboard/SettingsIcon.svg"
import SystemNotificationIcon from "./Dashboard/SystemNotificationIcon.svg"
import WorkshopIcon from "./Dashboard/WorkshopIcon.svg"
import ptaBoxImage from "./SchoolAdmin/ptaBoxImage.svg"
import cloudGif from "./SchoolAdmin/cloud.gif";
import closeIcon from "./closeIcon.svg";
import deleteIcon from "./landingPage/deleteIcon.svg";
import podcast from "./SchoolAdmin/podcast.png";
import pdfImg from "./SchoolAdmin/Pdf_Img.png";
import csvImg from "./SchoolAdmin/Csv_Img.png";
import Check from "./Check.svg";
import CheckCircle from "./CheckCircle.svg";
import UploadIcon from "./UploadIcon.svg";
import UploaderContainer from "./uploderContainer.svg";
import logoutGif from './logout.gif';
import userImage from './SchoolAdmin/teachers/userImage.svg';
import searchIcon from './SchoolAdmin/teachers/searchIcon.svg';
import plusIcon from './SchoolAdmin/teachers/plusIcon.svg';
import teacher1 from './SchoolAdmin/teachers/teacher1.svg';
import backArrow from "./Dashboard/backArrow.png"
import solidinterfaceplus from './SchoolAdmin/solidinterfaceplus.svg'
import User from './SchoolAdmin/User.png'
import noUserProfile from './Teachers/noUserProfile.png';
import MoreIcon from './MoreIcon.svg';
import teacherDeleteIcon from './Teachers/deleteIcon.png';
import addIcon from "./SchoolAdmin/AddIcon.svg";
import UpArrow from "./SchoolAdmin/classroom/upArrow.svg";
import DownArrow from "./SchoolAdmin/classroom/downArrow.svg";
import bookIcon from './SchoolAdmin/classroom/bookIcon.svg';
import classroomTabAdImage from './SchoolAdmin/classroom/classroomTabAd.png';
import CopyCode from './SchoolAdmin/classroom/CopyCode.svg';
import ResetCode from './SchoolAdmin/classroom/ResetCode.svg';
import DeleteClass from './SchoolAdmin/classroom/DeleteClass.svg';
import DeleteGif from './delete.gif';
import rightSideArrow from './Teachers/rightSideArrow.svg';
import EbookImage from './Teachers/EbookImage.png';
import ImagesCardImage from './Teachers/imagesCardImage.png';
import PodcastImage from './Teachers/podcastImage.png';
import SyndicatedVideoImage from './Teachers/syndicatedVideoImage.png';
import exitIcon from './Teachers/exitIcon.svg';
import englishSubject from './Teachers/englishSubImage.svg';
import mathsSubject from './Teachers/mathsSubImage.svg';
import scienceSubject from './Teachers/scienceSubImage.svg';
import LoadingGif from './Loading.gif';
import redDotImage from './Teachers/redDotImage.svg';
import EnglishHeader from './Subjects/englishHeader.png';
import uploadCloud from './Subjects/uploadCloud.svg';
import SearchBlack from './Subjects/SearchBlack.svg';
import ShareIcon from './Subjects/Share.svg';
import ShareWhiteIcon from './Teachers/Videos/shareWhiteIcon.svg';
import greyMoreIcon from './Teachers/greyMoreIcon.svg';
import guideDefaultImage from './Teachers/guideDefaultImage.jpg';
import UploadFailedSvg from './UploadFailedSvg.svg';
import LiveSessionGif from './Teachers/LiveSessionGif.gif';
import calendarSymbol from './Teachers/Liveclass/calendarIcon.svg';
import clockSymbol from './Teachers/Liveclass/timeIcon.svg';
import sandWatch from './Teachers/Liveclass/hour-glass.svg';
import SavedVideo1 from './Teachers/Liveclass/savedVideo1.mp4'
import SavedVideo2 from './Teachers/Liveclass/savedVideo2.mp4'
import videoPlayIcon from './Teachers/Liveclass/videoPlayIcon.svg';
import whiteCrossIcon from './Teachers/Liveclass/whiteCrossIcon.svg';
import expandVideoIcon from './Teachers/Liveclass/expandVideoIcon.svg';
import PodcastPlayButton from './Teachers/PodcastPlayButton.png';
import DeleteWithBlueBg from './Teachers/DeleteWithBlueBg.svg';
import CloudDownload from './Teachers/Cloud-download.svg';
import CoverPlusImage from './Teachers/podcast/CoverPlusImage.svg';
import pauseIcon from './Teachers/podcast/playIcon.svg';
import playIcon from './Teachers/podcast/pauseIcon.svg';
import rewindIcon from './Teachers/podcast/RewindIcon.svg';
import forwardIcon from './Teachers/podcast/ForwardIcon.svg';
import volumeUpIcon from './Teachers/podcast/Volume-up.svg';
import volumeDownIcon from './Teachers/podcast/Volume-off.svg';
import podcastDefaultImage from './Teachers/podcast/podcastDefaultImage.png';
import ShareGif from './Teachers/audiences.gif';
import quizIcon from './Teachers/Quiz/quizIcon.gif'
import RightClickArrow from './Students/RightClickArrow.svg';
import WhiteMoreIcon from './Teachers/Liveclass/WhiteMoreIcon.svg';
import MoreSmallWhiteIcon from './Teachers/Videos/MoreSmallWhiteIcon.svg';
import whiteTick from './White_tick.svg';
import whiteClose from './White_Cross.svg';
import docsImg from './Teachers/Quiz/docsImg.svg'
import forwardBlack from './Teachers/Quiz/Forward_Black.svg';
import quizStudent from './Teachers/Quiz/Quiz_student.svg';
import Crying from './LiveClass/Crying.gif';
import chatActive from './Meet/chat_active.png';
import chatInactive from './Meet/chat_inactive.png';
import groupActive from './Meet/group_active.png';
import groupInactive from './Meet/group_inactive.png';
import BlueArrow from '../images/BlueArrow.svg';
import participantsActive from './Meet/participants_active.png';
import participantsInactive from './Meet/participants_inactive.png';
import mute from './Meet/Mute.png';
import unmute from './Meet/unmute.png';
import videoOn from './Meet/video_on.png';
import videoOff from './Meet/video_off.png';
import Microphone from './LiveClass/Microphone.svg';
import MicrophoneOff from './LiveClass/Microphone-off.svg';
import VideoOff from './Meet/VideoOff.svg';
import VideoOn from './Meet/VideoOn.svg';
import MicOn from './Meet/MicOn.svg';
import MicOff from './Meet/MicOff.svg';
import HandOn from './Meet/HandOn.svg';
import HandOff from './Meet/HandOff.svg';
import EndCall from './Meet/EndCall.svg';
import ChatInactive from './Meet/Chat_Inactive.svg';
import ChatActive from './Meet/Chat_Active.svg';
import Send from './Meet/Send.svg';
import GroupsInactive from './Meet/Groups_Inactive.svg';
import ParticipantsInactive from './Meet/Participants_Inactive.svg';
import ScheduleWorkshopGif from './SchoolAdmin/workshop/scheduleWorkshopGif.gif';
import BluePlayButton from './SchoolAdmin/workshop/bluePlayButton.svg';
import videoPlay from './Teachers/Videos/videoPlay.png';
import CloudWhiteDownload from './Teachers/Videos/CloudWhiteDownload.svg';
import DownloadFailed from './DownloadFailed.svg';
import DownloadSuccess from './DownloadSuccess.svg';
import Checkbox_outline from './Teachers/Quiz/Checkbox_outline.svg';
import Checkbox_checked from './Teachers/Quiz/Checkbox_checked.svg';
import Checkbox_checked_green from './Teachers/Quiz/Checkbox_checked_Green.svg';
import Checkbox_checked_wrong from './Teachers/Quiz/Checkbox_wrong.svg';
import Quiz_gif from './Teachers/Quiz/Quiz_gif.gif';
import studentProfile from './Teachers/Quiz/Student_Profile.svg';
import VideoConfGif from './SchoolAdmin/workshop/VideoConfGif.gif';
import deleteIconGray from './SchoolAdmin/Calendar/deleteIconGray.svg';
import MoreIconBig from './SchoolAdmin/Calendar/MoreIconBig.svg';
import MenuShareIcon from './SchoolAdmin/Calendar/ShareIcon.svg';
import PublishLavender from './SchoolAdmin/Calendar/PublishLavender.svg';
import PublishRed from './SchoolAdmin/Calendar/PublishRed.svg';
import PublishYellow from './SchoolAdmin/Calendar/PublishYellow.svg';
import BackIconGray from './SchoolAdmin/Calendar/BackIconGray.svg';
import AnnouncementIcon from './Dashboard/AnnouncementIcon.svg';
import AnnouncementImage from './Dashboard/Announcement.jpg';
import PencilIcon from './SchoolAdmin/Calendar/PencilIcon.svg';
import ParticipantMuteIcon from './Meet/participantMuteIcon.svg';
import ParticipantUnMuteIcon from './Meet/participantUnMuteIcon.svg';
import ParticipantVideoOnIcon from './Meet/participantVideoOnIcon.svg';
import ParticipantVideoOffIcon from './Meet/participantVideoOffIcon.svg';
import ParticipantRaiseHand from './Meet/raise-hand.svg';
import PTA_Background from  './PTA/PTA_Background.svg';
import PTA_meeting_icon from  './PTA/PTA_meeting_icon.svg';
import NoMeeting from './PTA/NoMeetings.gif';
import GroupChatIcon from './CommonChat/groupChatIcon.svg';
import UserActiveIcon from './CommonChat/userActiveIcon.svg';
import assignmentUser from './Teachers/Assignments/User.png';
import voiceChatIcon from './CommonChat/voiceChatIcon.svg';
import sendIcon from './CommonChat/SendIcon.svg';
import AttachmentIcon from './CommonChat/AttachmentIcon.svg';
import ScreenSharingIcon from './Meet/screenShareVideo.svg';
import sorrygif from './PTA/sorry.gif';
import Pin from './Meet/Pin.svg';
import Unpin from './Meet/Unpin.svg';
import PopupCloseIcon from './Meet/popupCloseIcon.svg';
import studentCheckboxAllOutline from './SchoolAdmin/students/studentCheckboxAllOutline.svg';
import studentCheckboxAllChecked from './SchoolAdmin/students/studentCheckboxAllChecked.svg';
import studentCheckboxChecked from './SchoolAdmin/students/studentCheckboxChecked.svg';
import studentCheckboxOutline from './SchoolAdmin/students/studentCheckboxOutline.svg';
import ShareIconStudent from './SchoolAdmin/students/ShareIconStudent.svg';
import AddSubjectIcon from './SchoolAdmin/classroom/AddSubjectIcon.svg';
import StopIcon from './CommonChat/StopIcon.svg';
import StopIconRed from './CommonChat/StopIconRed.svg';
import chatImage from './CommonChat/chatImage.svg';
import chatDocument from './CommonChat/chatDocument.svg';
import SendDisableIcon from './CommonChat/SendDisableIcon.svg';
import closeIconround from './Close.svg'
import Location from './Location.svg'
import Phone from './Phone.svg'
import Envelope from './Envelope.svg'
import backArrowWhite from './backArrowWhite.svg';
import Legal from './Legal.svg';
import excelPreview from './SchoolAdmin/excelPreview.svg';
import acknowledgement from './learn_icon.svg'
import system_update from './System_update.svg'
import faq from './Faq.svg'
import powerpoint from './SchoolAdmin/powerpoint.svg';
import documentsystemMessages from './documentsystemMessages.svg';
import epub from '../images/SchoolAdmin/epub.png';
import ChatReply from './CommonChat/ChatReply.svg';
import ChatEdit from './CommonChat/ChatEdit.svg';
import ChatEmoji from './CommonChat/ChatEmoji.svg';
import ChatDeletedMessage from './CommonChat/ChatDeletedMessage.svg';
import emoji2 from './emoji2.svg';
import messageGif from './message.gif';
import imageSvg from './image.svg';
import JitsiStartRecordingIcon from './jitsi-start-recording.svg';
import JitsiStopRecordingIcon from './jitsi-stop-recording.svg';
import audioSvg from './audio.svg';
import StarIcon from './startIcon.svg';
import EmptyIcon from './emptyIcon.svg';
import GreenTickIcon from './VirtualSchool/greenTickIcon.svg';
import greyArrow from './GreyArrow.svg'
import selectedProgramTick from './VirtualSchool/selectedProgram.svg';
import virtualClassAdminProfile from './VirtualClassAdminProfile.svg'
import GroupPersons from './VirtualSchool/GroupPersons.svg';
import TwoPersons from './VirtualSchool/twoPersons.svg';
import advertisement from './advertisement.svg';
import teacherProfile from './teacherProfile.svg';
import rating from './star.svg';
import katonLogo from './landingPage/360classroom.svg'
import GreenCircleWithChecked from './landingPage/GreenCircleWithChecked.svg'
import katonHeaderLogoVirtual from './landingPage/katonHeaderLogoVirtual.svg';
import menuIcon from './MobileResponsive/menuIcon.svg';
import logoutIconMobile from './MobileResponsive/logoutIconMobile.svg';
import WorkshopFacilitatorActive from './MobileResponsive/WorkshopFacilitatorActive.svg';
import WorkshopFacilitatorInActive from './MobileResponsive/WorkshopFacilitatorInActive.svg';
import workshopParticipantActive from './MobileResponsive/workshopParticipantActive.svg';
import workshopParticipantInactive from './MobileResponsive/workshopParticipantInactive.svg';
import searchCloseIcon from './MobileResponsive/searchCloseIcon.svg';
import KatonLogoBlue from "./landingPage/KatonLogoBlue.svg";
import classroomActiveIcon from './MobileResponsive/classroomActiveIcon.svg';
import classroomInactiveIcon from './MobileResponsive/classroomInactiveIcon.svg';
import announcementActiveIcon from './MobileResponsive/announcementActiveIcon.svg';
import announcementInactiveIcon from './MobileResponsive/announcementInactiveIcon.svg';
import ScheduleMeeting from './MobileResponsive/ScheduleMeeting.svg';
import LegalBackIcon from './legalBackIcon.svg';
import settings_active from './MobileResponsive/settings_active.svg';
import settings_inactive from './MobileResponsive/settings_inactive.svg';
import ImagePlaceholder from './image-placeholder.svg';
import uploadIconMobile from './MobileResponsive/uploadIcon.svg';  
import MobileDashboardActive from './MobileResponsive/MobileDashboardActive.svg';
import MobileDashboardInactive from './MobileResponsive/MobileDashboardInactive.svg';
import MobileWorkshopActive from './MobileResponsive/MobileWorkshopActive.svg';
import MobileWorkshopInactive from './MobileResponsive/MobileWorkshopInactive.svg';
import MobileNotificationInactive from './MobileResponsive/MobileNotificationInactive.svg';
import MobileNotificationActive from './MobileResponsive/MobileNotificationActive.svg';
import MobileSystemMessageActive from './MobileResponsive/MobileSystemMessageActive.svg';
import MobileSystemMessageInactive from './MobileResponsive/MobileSystemMessageInactive.svg';
import MobileHelp from './MobileResponsive/MobileHelp.png';
import ActiveCalendarIcon from './MobileResponsive/ActiveCalendarIcon.svg';
import InActiveCalendarIcon from './MobileResponsive/InActiveCalendarIcon.svg';
import ActiveCalenderComponentIcon from './MobileResponsive/ActiveCalenderComponetIcon.svg';
import InActiveCalenderComponentIcon from './MobileResponsive/InActiveCalenderComponetIcon.svg';
import InActiveFavouriteIcon from './MobileResponsive/InActiveFavouriteIcon.svg';
import ActiveFavouriteIcon from './MobileResponsive/ActiveFavouriteIcon.svg';
import MobileAddTeacher from './MobileResponsive/MobileAddTeacher.svg';
import leftWhiteArrow from './MobileResponsive/leftWhiteArrow.svg';
import rightWhiteArrow from './MobileResponsive/rightWhiteArrow.svg';
import StudentShareIconMobile from './MobileResponsive/StudentShareIconMobile.svg';
import AnnouncementIconActive from './ic-announcement-active.svg';
import AnnouncementIconInActive from './ic-announcement-inactive.svg';
import ptaOtherMeetingInactive from "./MobileResponsive/pta_other_meeting_inactive.svg";
import ptaOtherMeetingActive from "./MobileResponsive/pta_other_meeting_active.svg";
import mobileGeneralMeetingActive from "./MobileResponsive/mobile_general_meeting_active.svg";
import mobileGeneralMeetingInActive from "./MobileResponsive/mobile_general_meeting_inactive.svg";
import CopyCodeWhite from './SchoolAdmin/classroom/CopyCodeWhite.svg';
import DeleteQuiz from './quizDelete.svg';
import UploadIconDashboard from "./Dashboard/Upload.svg";
import TickIcon from "./TickIcon.svg";
import BulkUplodIcon from "./bulkuploadIcon.svg";
import muteIcon from './mute_mobile.svg';
import unMuteIcon from './unmute_mobile.svg';
import sendMessageIcon from './send_message.svg'; 
import recording_mobile from "./recording_mobile.svg"
import RecordingIconMobile from './mobile_recording.svg';
import mobileParticipants from './mobile_participants.svg';
import selectedAllParticipants from './selected_all_participants.svg';

const images = {
    AdminBottomImage,Facebook,instagram,katonHeaderLogo,kid,linkedin,teacherLoginBottomImage,
    ptaBottomImage,tiktokIcon,xIcon,youtubeIcon,underContstructionImage,splashImage,
    adminLoginPageLamp,landingPageImage,ptaCornerImage,cloudGif,closeIcon,deleteIcon,podcast,pdfImg,csvImg,
    CheckCircle,Check,UploadIcon,schoolProfileImage,DashboardIcon,HelpIcon,LogoutIcons,NotificationIcon,
    SettingsIcons,SystemNotificationIcon,WorkshopIcon,ptaBoxImage,userImage, searchIcon, 
    plusIcon, teacher1, adminLoginPageLampPng,backArrow,solidinterfaceplus,User, noUserProfile, logoutGif,
    UploaderContainer, MoreIcon,teacherDeleteIcon,addIcon,UpArrow,DownArrow, bookIcon, 
    classroomTabAdImage,CopyCode,ResetCode,DeleteClass,DeleteGif,LoadingGif,rightSideArrow, EbookImage, 
    ImagesCardImage, PodcastImage, SyndicatedVideoImage, redDotImage,
    exitIcon, englishSubject, mathsSubject, scienceSubject, EnglishHeader, uploadCloud, 
    SearchBlack, ShareIcon, greyMoreIcon, guideDefaultImage, UploadFailedSvg, LiveSessionGif,calendarSymbol,
    clockSymbol, sandWatch, SavedVideo1, SavedVideo2, videoPlayIcon, whiteCrossIcon, expandVideoIcon,
    PodcastPlayButton, DeleteWithBlueBg, CloudDownload, CoverPlusImage, playIcon, pauseIcon,
    rewindIcon, forwardIcon, volumeUpIcon, volumeDownIcon, podcastDefaultImage, ShareGif, quizIcon, RightClickArrow,
    WhiteMoreIcon, whiteTick, whiteClose, docsImg, forwardBlack, quizStudent, chatActive, chatInactive, groupActive,
    groupInactive, participantsActive, participantsInactive, Crying, mute, unmute, videoOn, videoOff, MicrophoneOff, Microphone, 
    EndCall, MicOff, MicOn, VideoOn, VideoOff, ParticipantsInactive, GroupsInactive, ChatInactive, ChatActive, Send, videoPlay,
    ScheduleWorkshopGif, BluePlayButton, ShareWhiteIcon, MoreSmallWhiteIcon, CloudWhiteDownload, DownloadFailed, DownloadSuccess,
    Checkbox_outline, Quiz_gif, Checkbox_checked_green, studentProfile, Checkbox_checked_wrong, Checkbox_checked, VideoConfGif,
    deleteIconGray, MoreIconBig, MenuShareIcon, PublishLavender, PublishRed, PublishYellow, BackIconGray,
    AnnouncementIcon, AnnouncementImage, PencilIcon, ParticipantMuteIcon, ParticipantUnMuteIcon, ParticipantVideoOnIcon,  
    ParticipantVideoOffIcon, ParticipantRaiseHand, PTA_Background, PTA_meeting_icon, NoMeeting, BlueArrow,
    ScreenSharingIcon, sorrygif, assignmentUser, Pin, Unpin, PopupCloseIcon, GroupChatIcon,
    UserActiveIcon, voiceChatIcon, sendIcon, AttachmentIcon, studentCheckboxOutline, studentCheckboxChecked, studentCheckboxAllChecked, 
    studentCheckboxAllOutline, ShareIconStudent, AddSubjectIcon, closeIconround, HandOn, HandOff, StopIcon, chatImage, chatDocument, SendDisableIcon,
    backArrowWhite, Location, Phone, Envelope, Legal, excelPreview, acknowledgement, system_update, faq, powerpoint, documentsystemMessages,
    epub, ChatReply, ChatEdit, ChatEmoji, ChatDeletedMessage, StopIconRed, emoji2, messageGif, imageSvg,JitsiStartRecordingIcon, JitsiStopRecordingIcon,
    audioSvg, greyArrow, selectedProgramTick, virtualClassAdminProfile, StarIcon, EmptyIcon, GreenTickIcon, GroupPersons,
    TwoPersons, advertisement, teacherProfile, rating, katonLogo, GreenCircleWithChecked, katonHeaderLogoVirtual, menuIcon, 
    logoutIconMobile, WorkshopFacilitatorActive, WorkshopFacilitatorInActive, workshopParticipantInactive, workshopParticipantActive,
    searchCloseIcon, KatonLogoBlue, classroomActiveIcon, classroomInactiveIcon, announcementActiveIcon, announcementInactiveIcon, ScheduleMeeting,
    LegalBackIcon, settings_inactive, settings_active, uploadIconMobile, MobileDashboardInactive, MobileDashboardActive, MobileWorkshopActive, MobileWorkshopInactive,
    MobileNotificationActive, MobileNotificationInactive, MobileSystemMessageInactive, MobileSystemMessageActive, MobileHelp, MobileAddTeacher,
    ActiveCalendarIcon,InActiveCalendarIcon,ActiveCalenderComponentIcon,InActiveCalenderComponentIcon,InActiveFavouriteIcon,
    ActiveFavouriteIcon, ImagePlaceholder, leftWhiteArrow, rightWhiteArrow,
    StudentShareIconMobile, AnnouncementIconActive, AnnouncementIconInActive, mobileGeneralMeetingInActive,
    mobileGeneralMeetingActive, ptaOtherMeetingActive, ptaOtherMeetingInactive, CopyCodeWhite, DeleteQuiz, UploadIconDashboard, TickIcon, BulkUplodIcon,
    muteIcon, unMuteIcon, sendMessageIcon, recording_mobile, RecordingIconMobile, mobileParticipants, selectedAllParticipants
}


export default images;
